import { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CompassOutlined, ClusterOutlined, LogoutOutlined, CarOutlined, DeploymentUnitOutlined, GroupOutlined } from '@ant-design/icons';
import { UserContext } from './Components/UserContext';
import ExploreIcon from '@mui/icons-material/Explore';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import ThreeDRotationIcon from '@mui/icons-material/ThreeDRotation';
import PublicSharpIcon from '@mui/icons-material/PublicSharp';

export default function NavBar() {
  const { loggedIn, setLoggedIn, userName } = useContext(UserContext);
  const navigate = useNavigate();
  const [isMapsOpen, setIsMapsOpen] = useState(false);
  const [isHodakevOpen, setIsHodakevOpen] = useState(false);

  const handleLogout = () => {
    setLoggedIn(false);
    navigate('/');
  };


  return (
    <>
     <style>
      {`
        .nav-link:hover {
          background-color: #283593;
          border-radius: 4px;
        }
        .dropdown-item:hover {
          background-color: #e0f7fa;
        }
      `}
    </style>

      {loggedIn && (
        <nav className="navbar navbar-expand-lg navbar-dark" style={{ backgroundColor: '#000068' }}>
            <img
              src="/Images/MobileGroupLogoNavBar.png"
              style={{ width: '150px', height: '50px', position: 'relative',left:"5px", display: 'flex' }}
              alt="mobileGroupLogo"
            />
          <ul className="navbar-nav me-auto mb-2 mb-lg-0" style={{ marginLeft: '50px' }}>
            {/* Maps Dropdown */}
            <li
              className="nav-item"
              onMouseEnter={() => setIsMapsOpen(true)}
              onMouseLeave={() => setIsMapsOpen(false)}
            >
              <span className="nav-link" style={{ cursor: 'pointer', color: "#00B8A1" }}>
                <CompassOutlined /> Maps
              </span>
              {isMapsOpen && (
                <div className="dropdown-menu" style={{ display: 'block', color: "#00B8A1" }}>
                  <Link to="/map" className="dropdown-item" style={{ color: "#00B8A1" }}>
                    <ExploreIcon /> Map
                  </Link>
                  <Link to="/3dmap" className="dropdown-item" style={{ color: "#00B8A1" }}>
                    <ThreeDRotationIcon /> 3D Map
                  </Link>
                  <Link to="/mapBoxTerrin" className="dropdown-item" style={{ color: "#00B8A1" }}>
                    <PublicSharpIcon /> Terrain 3D Map
                  </Link>
                </div>
              )}
            </li>

            {/* HodAkev Dropdown */}
            <li
              className="nav-item"
              onMouseEnter={() => setIsHodakevOpen(true)}
              onMouseLeave={() => setIsHodakevOpen(false)}
            >
              <span className="nav-link" style={{ cursor: 'pointer', color: "#00B8A1" }}>
                <FingerprintIcon /> Hod Akev
              </span>
              {isHodakevOpen && (
                <div className="dropdown-menu" style={{ display: 'block', color: "#00B8A1" }}>
                  <Link to="/hodAkevGroups" className="dropdown-item" style={{ color: "#00B8A1" }}>
                    <GroupOutlined /> HodAkev Groups
                  </Link>
                  <Link to="/showMarkers" className="dropdown-item" style={{ color: "#00B8A1" }}>
                    <ClusterOutlined /> Show Markers
                  </Link>
                </div>
              )}
            </li>

            {/* Conditionally render FOTA */}
            {userName !== 'ARMONIC' && (
              <li className="nav-item">
                <Link className="nav-link" to="/fota" style={{ color: "#00B8A1" }}>
                  <CarOutlined /> FOTA
                </Link>
              </li>
            )}
            <li className="nav-item">
              <Link className="nav-link" to="/mgConnect" style={{ color: "#00B8A1" }}>
                <DeploymentUnitOutlined /> MG Connect
              </Link>
            </li>
          </ul>
          <button className="btn btn-outline-light" style={{ color: "#00B8A1", borderColor: "#00B8A1", margin: "5px" }} onClick={handleLogout}>
            <LogoutOutlined /> Logout
          </button>
        </nav>
      )}
    </>
  );
};
